export default {
  global: {
    footnote: 'All rights reserved 2018 &#9400; FeatSoftware',
  },
  404: {
    description: 'This page does not exist',
  },
  menu: {
    home: 'Home',
    caseStudies: 'Case studies',
    about: 'About',
    contact: 'Contact',
    nautilius: 'Nautilius Investment',
    omegaGroup: 'Omega Group',
    omegaWeb: 'Omega Web Platform',
    omegaHolding: 'Omega holding',
  },
};
